import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../../../../assets/images/music/back.png';
import _imports_1 from '../../../../assets/images/music/download.png';
import _imports_2 from '../../../../assets/images/music/disc.png';
import _imports_3 from '../../../../assets/images/music/stop.png';
import _imports_4 from '../../../../assets/images/music/play.png';
const _hoisted_1 = { class: "music-player" };
const _hoisted_2 = { class: "main" };
const _hoisted_3 = { class: "flexColumn container" };
const _hoisted_4 = { class: "header flexRow-alc flex-jcsb" };
const _hoisted_5 = { class: "content flexRow flex-jcc flex-als" };
const _hoisted_6 = { class: "lyrics-container" };
const _hoisted_7 = { class: "top" };
const _hoisted_8 = { class: "title" };
const _hoisted_9 = { class: "author" };
const _hoisted_10 = {
    key: 0,
    class: "lyrics_text"
};
const _hoisted_11 = {
    key: 1,
    class: "lyrics flexRow-juc"
};
const _hoisted_12 = {
    key: 0,
    class: "progress-bar"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = { class: "audio_right" };
const _hoisted_15 = { class: "bottom" };
const _hoisted_16 = { class: "audio_current" };
const _hoisted_17 = {
    key: 0,
    class: "audio_icon",
    src: _imports_3,
    alt: "播放"
};
const _hoisted_18 = {
    key: 1,
    class: "audio_icon",
    src: _imports_4,
    alt: "暂停"
};
const _hoisted_19 = { class: "audio_total" };
const _hoisted_20 = {
    key: 1,
    class: "cancel_tips"
};
import { nextTick, onMounted, onBeforeUnmount, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import chat from '../../../../utils/AI/chat';
import emitter from '../../../../utils/eventBus';
export default /*@__PURE__*/ _defineComponent({
    __name: 'music_chat',
    props: {
        sessionId: {},
        songBanner: {},
        songName: {},
        moodName: {},
        genreName: {},
        lyrics: {},
        audioUrl: {},
        detailId: {}
    },
    setup(__props) {
        const props = __props;
        const info = ref({});
        watch(() => props.lyrics, val => {
            if (!val)
                return;
            info.value = {
                gptDescriptionPrompt: `${props.moodName}/${props.genreName}`,
                songBanner: props.songBanner,
                songName: props.songName,
                lyrics: props.lyrics,
                src: props.audioUrl
            };
            nextTick(() => {
                var _a;
                if ((_a = info === null || info === void 0 ? void 0 : info.value) === null || _a === void 0 ? void 0 : _a.src)
                    calculateDuration();
            });
        });
        watch(() => props.sessionId, val => {
            if (props.sessionId)
                musicAI(props.sessionId);
        });
        watch(() => props.detailId, val => {
            if (props.detailId)
                musicAI(props.detailId);
        });
        // 获取歌曲
        const checkStatus = ref(null);
        const loading = ref(false);
        const musicAI = async (id) => {
            loading.value = true;
            try {
                // 初始化轮询
                const endStatus = [20, 30];
                let response;
                checkStatus.value = setInterval(async () => {
                    response = await chat.getMyMusic({
                        id
                    });
                    // 如果status为0，则停止轮询
                    if (endStatus.includes(response.status)) {
                        clearInterval(checkStatus.value);
                        loading.value = false;
                        if (response.status == 20) {
                            info.value = {
                                gptDescriptionPrompt: response.gptDescriptionPrompt,
                                songBanner: response.imageUrl || '',
                                songName: response.title,
                                lyrics: response.lyric,
                                src: response.audioUrl
                            };
                            setTimeout(() => {
                                nextTick(() => {
                                    var _a;
                                    if ((_a = info === null || info === void 0 ? void 0 : info.value) === null || _a === void 0 ? void 0 : _a.src)
                                        calculateDuration();
                                });
                            }, 400);
                        }
                        else if (response.status == 30) {
                            return ElMessage.warning('生成失败');
                        }
                    }
                }, 3000); // 每秒检查一次
            }
            catch (error) {
                loading.value = false;
            }
        };
        // 获取歌曲详情
        const getDetail = async () => {
            try {
                loading.value = true;
                const res = await chat.getMyMusic({
                    id: props.detailId
                });
                loading.value = false;
                if (!res)
                    return;
                info.value = {
                    gptDescriptionPrompt: res === null || res === void 0 ? void 0 : res.gptDescriptionPrompt,
                    songBanner: res === null || res === void 0 ? void 0 : res.imageUrl,
                    songName: res === null || res === void 0 ? void 0 : res.title,
                    lyrics: res === null || res === void 0 ? void 0 : res.lyric,
                    src: res === null || res === void 0 ? void 0 : res.audioUrl
                };
                setTimeout(() => {
                    nextTick(() => {
                        var _a;
                        if ((_a = info === null || info === void 0 ? void 0 : info.value) === null || _a === void 0 ? void 0 : _a.src)
                            calculateDuration();
                    });
                }, 400);
            }
            catch (error) {
                loading.value = false;
            }
        };
        /**
         * 播放器
         */
        const audioIsPlay = ref(true); //音频是否在播放
        const audioStart = ref('0:00');
        const durationTime = ref('0:00'); //音频的总时长，显示的时间格式
        const duration = ref(0); //音频的总时长
        const audioRef = ref(null);
        const currentProgress = ref(0);
        const handleCloseMusic = () => {
            audioRef.value.pause();
            audioIsPlay.value = true;
        };
        // 获取音频时长
        const calculateDuration = () => {
            var _a;
            var myVid = audioRef.value;
            myVid.loop = false;
            myVid.src = (_a = info.value) === null || _a === void 0 ? void 0 : _a.src;
            // 监听音频播放完毕
            myVid.addEventListener('ended', function () {
                audioIsPlay.value = true;
                currentProgress.value = 0;
            }, false);
            if (myVid != null) {
                myVid.oncanplay = function () {
                    duration.value = myVid.duration; // 计算音频时长
                    durationTime.value = transTime(myVid.duration); //换算成时间格式
                };
                // myVid.volume = 0.8 // 设置默认音量50%
                // 进入页面默认开始播放
                audioRef.value.play();
                audioIsPlay.value = false;
            }
        };
        watch(() => duration.value, val => {
            startAnimationAndScroll();
        });
        // 音频播放时间换算
        const transTime = duration => {
            const minutes = Math.floor(duration / 60);
            const seconds = Math.floor(duration % 60);
            const formattedMinutes = String(minutes).padStart(2, '0'); //padStart(2,"0") 使用0填充使字符串长度达到2
            const formattedSeconds = String(seconds).padStart(2, '0');
            return `${formattedMinutes}:${formattedSeconds}`;
        };
        // 播放暂停控制
        const playAudio = () => {
            if (audioRef.value.paused) {
                audioRef.value.play();
                audioIsPlay.value = false;
            }
            else {
                audioRef.value.pause();
                audioIsPlay.value = true;
            }
        };
        // 根据当前播放时间，实时更新进度条
        const updateProgress = e => {
            var _a, _b;
            var value = e.target.currentTime / e.target.duration;
            if ((_a = audioRef === null || audioRef === void 0 ? void 0 : audioRef.value) === null || _a === void 0 ? void 0 : _a.play) {
                currentProgress.value = value * 100;
                audioStart.value = transTime((_b = audioRef === null || audioRef === void 0 ? void 0 : audioRef.value) === null || _b === void 0 ? void 0 : _b.currentTime);
            }
        };
        //调整播放进度
        const handleProgressChange = val => {
            if (!val) {
                return;
            }
            let currentTime = duration.value * (val / 100);
            // 更新音频的当前播放时间
            audioRef.value.currentTime = currentTime;
        };
        const coverImgRef = ref(null);
        const lyricsContainerRef = ref(null);
        const scrollLyrics = ref(() => { });
        const startAnimationAndScroll = () => {
            if (!duration.value)
                return;
            if (coverImgRef.value) {
                coverImgRef.value.style.animationPlayState = 'running'; // 开始旋转动画
            }
            if (lyricsContainerRef.value && audioRef.value) {
                const lyricsContainer = lyricsContainerRef.value;
                const totalDuration = audioRef.value.duration || 0;
                const lyricsText = lyricsContainer.innerText.split('\n');
                const lyricsCount = lyricsText.length;
                // 减慢歌词播放速度，可以通过增加倍数来实现，这里假设减慢2度
                const timePerLine = (totalDuration / lyricsCount) * 1.5;
                let startTime = null;
                scrollLyrics.value = (timestamp) => {
                    var _a;
                    if (!startTime)
                        startTime = timestamp;
                    const elapsed = timestamp - startTime;
                    const currentTime = (_a = audioRef === null || audioRef === void 0 ? void 0 : audioRef.value) === null || _a === void 0 ? void 0 : _a.currentTime;
                    // 确保 timePerLine 不为 0
                    if (timePerLine === 0) {
                        timePerLine = 1; // 设置一个默认值，或者根据实际情况处理
                    }
                    // 计算当前应该显示的歌词行索引
                    const currentLineIndex = Math.floor(currentTime / timePerLine);
                    if (isNaN(currentLineIndex) || !isFinite(currentLineIndex)) {
                        // 处理 NaN 或 Infinity 的情况，例如设置默认值
                        currentLineIndex = 0; // 默认值
                    }
                    // 高亮当前歌词行
                    lyricsText.forEach((line, index) => {
                        const lineElement = lyricsContainer.children[index];
                        if (lineElement) {
                            lineElement.classList.toggle('highlight', index === currentLineIndex);
                        }
                    });
                    // 滚动到当前歌词行
                    const currentLineElement = lyricsContainer.children[currentLineIndex];
                    if (currentLineElement) {
                        lyricsContainer.scrollTop = currentLineElement.offsetTop - lyricsContainer.clientHeight / 2 + currentLineElement.clientHeight / 2;
                    }
                    if (currentTime <= totalDuration) {
                        requestAnimationFrame(scrollLyrics.value);
                    }
                    else {
                        lyricsContainer.scrollTop = 0; // 重置滚动位置
                    }
                };
                // 确保 scrollLyrics.value 是一个函数
                if (typeof scrollLyrics.value === 'function') {
                    requestAnimationFrame(scrollLyrics.value);
                }
            }
        };
        const stopAnimationAndScroll = () => {
            if (coverImgRef.value) {
                coverImgRef.value.style.animationPlayState = 'paused'; // 停止旋转动画
            }
            if (lyricsContainerRef.value && scrollLyrics.value) {
                cancelAnimationFrame(scrollLyrics.value); // 取消当前的动画帧请求
                scrollLyrics.value = () => { }; // 清空动画帧请求的ID
            }
        };
        // 监听音频播放状态
        watch(audioIsPlay, isPlaying => {
            if (isPlaying) {
                stopAnimationAndScroll();
            }
            else {
                startAnimationAndScroll();
            }
        });
        // 监听音频播放结束事件
        const handleAudioEnded = () => {
            audioStart.value = '0:00';
            stopAnimationAndScroll();
        };
        // 下载
        const download = () => {
            const link = document.createElement('a');
            link.href = info.value.src;
            link.download = `${props.songName}.mp4`; // 设置下载的文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
        // 返回
        const goBack = () => {
            init();
            emitter.emit('closeMusic');
        };
        // 取消生成
        const cancel = () => {
            goBack();
            ElMessage.success('已取消');
        };
        const init = () => {
            clearInterval(checkStatus.value);
            info.value = {};
            loading.value = false;
            duration.value = 0;
            audioIsPlay.value = false;
            currentProgress.value = 0;
        };
        onMounted(() => {
            emitter.on('closeMusic', () => {
                init();
                stopAnimationAndScroll();
            });
        });
        onBeforeUnmount(() => {
            goBack();
            stopAnimationAndScroll();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
            const _component_el_skeleton = _resolveComponent("el-skeleton");
            const _component_el_slider = _resolveComponent("el-slider");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", {
                                class: "flexRow-alc clickable",
                                onClick: goBack
                            }, _cache[1] || (_cache[1] = [
                                _createElementVNode("img", {
                                    src: _imports_0,
                                    alt: "",
                                    class: "icon"
                                }, null, -1)
                            ])),
                            (((_a = info.value) === null || _a === void 0 ? void 0 : _a.src) && !loading.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "flexRow-alc clickable",
                                    onClick: download
                                }, _cache[2] || (_cache[2] = [
                                    _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "",
                                        class: "icon"
                                    }, null, -1)
                                ])))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "cover" }, [
                                _createElementVNode("img", {
                                    src: _imports_2,
                                    alt: "",
                                    class: "disc"
                                })
                            ], -1)),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_el_skeleton, {
                                    loading: loading.value,
                                    animated: ""
                                }, {
                                    template: _withCtx(() => [
                                        _createVNode(_component_el_skeleton_item, {
                                            variant: "rect",
                                            style: { "width": "50%", "height": "35px", "margin-bottom": "20px" }
                                        }),
                                        _createVNode(_component_el_skeleton_item, {
                                            variant: "rect",
                                            style: { "width": "50%", "height": "35px" }
                                        }),
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (item) => {
                                            return _createElementVNode("div", {
                                                class: "skeleton-item",
                                                key: item
                                            }, [
                                                _createVNode(_component_el_skeleton_item, {
                                                    variant: "text",
                                                    style: { "width": "100%", "margin-top": "20px", "height": "35px" }
                                                })
                                            ]);
                                        }), 64))
                                    ]),
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [])),
                                    _: 1
                                }, 8, ["loading"]),
                                (!loading.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, _toDisplayString((_b = info.value) === null || _b === void 0 ? void 0 : _b.songName), 1),
                                            _createElementVNode("div", _hoisted_9, _toDisplayString((_c = info.value) === null || _c === void 0 ? void 0 : _c.gptDescriptionPrompt), 1)
                                        ]),
                                        ((_d = info.value) === null || _d === void 0 ? void 0 : _d.lyrics)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                ref_key: "lyricsContainerRef",
                                                ref: lyricsContainerRef,
                                                class: "lyrics"
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_e = info.value) === null || _e === void 0 ? void 0 : _e.lyrics.split('\n'), (line, index) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                        (!['[chorus]', '[verse]'].includes(line))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(line), 1))
                                                            : _createCommentVNode("", true)
                                                    ], 64));
                                                }), 128)),
                                                _cache[4] || (_cache[4] = _createElementVNode("div", { style: { "height": "300px" } }, null, -1))
                                            ], 512))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[5] || (_cache[5] = [
                                                _createElementVNode("div", { class: "lyrics-tip" }, "暂无歌词", -1)
                                            ])))
                                    ], 64))
                                    : _createCommentVNode("", true),
                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mask" }, null, -1))
                            ])
                        ]),
                        (((_f = info.value) === null || _f === void 0 ? void 0 : _f.src) && !loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("audio", {
                                    onTimeupdate: updateProgress,
                                    controls: "",
                                    ref_key: "audioRef",
                                    ref: audioRef,
                                    onEnded: handleAudioEnded,
                                    style: { "display": "none" }
                                }, [
                                    _createElementVNode("source", {
                                        src: (_g = info.value) === null || _g === void 0 ? void 0 : _g.src,
                                        type: "audio/mpeg"
                                    }, null, 8, _hoisted_13),
                                    _cache[8] || (_cache[8] = _createTextVNode(" 您的浏览器不支持音频播放 "))
                                ], 544),
                                _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_el_slider, {
                                        class: "slider_box",
                                        modelValue: currentProgress.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentProgress).value = $event)),
                                        "show-tooltip": false,
                                        onInput: handleProgressChange
                                    }, null, 8, ["modelValue"]),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, _toDisplayString(audioStart.value), 1),
                                        _createElementVNode("div", {
                                            class: "flexRow-alc clickable",
                                            onClick: playAudio
                                        }, [
                                            (!audioIsPlay.value)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                                                : _createCommentVNode("", true),
                                            (audioIsPlay.value)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_19, _toDisplayString(durationTime.value), 1)
                                    ])
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _cache[9] || (_cache[9] = _createTextVNode("音乐正在生成中，平均需要20秒左右。")),
                                _createElementVNode("span", {
                                    class: "cancel clickable",
                                    onClick: cancel
                                }, "取消生成")
                            ]))
                    ])
                ])
            ]));
        };
    }
});
